import { render, staticRenderFns } from "./IgaliojimasNotaras.vue?vue&type=template&id=3c91236e&scoped=true&"
import script from "./IgaliojimasNotaras.vue?vue&type=script&lang=js&"
export * from "./IgaliojimasNotaras.vue?vue&type=script&lang=js&"
import style0 from "./IgaliojimasNotaras.vue?vue&type=style&index=0&id=3c91236e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91236e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VDataTable,VRow})
